(() => {
  'use strict';

  function initializeCustomSearch(drawer) {
    if (drawer.dataset.initialized === 'true') return;
    drawer.dataset.initialized = 'true';

    const input = drawer.querySelector('[data-custom-search-input]');
    const form = drawer.querySelector('[data-custom-search-form]');
    const results = drawer.querySelector('[data-custom-search-results]');
    const list = drawer.querySelector('[data-custom-search-list]');
    const empty = drawer.querySelector('[data-custom-search-empty]');
    const recommendations = drawer.querySelector('[data-custom-search-recommendations]');
    const configNode = drawer.querySelector('[data-custom-search-title-config]');
    let products = [];
    let timeoutId;
    let abortController;

    try {
      const parsed = JSON.parse(configNode?.textContent || '[]');
      products = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      products = [];
    }

    const triggers = () => document.querySelectorAll('[data-custom-search-open]');

    function resetContent() {
      window.clearTimeout(timeoutId);
      abortController?.abort();
      input.value = '';
      list.replaceChildren();
      results.hidden = true;
      empty.hidden = true;
      recommendations.hidden = false;
    }

    function openDrawer() {
      resetContent();
      drawer.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      triggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('custom-search-open');
      window.requestAnimationFrame(() => input.focus());
    }

    function closeDrawer() {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      triggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('custom-search-open');
      resetContent();
    }

    function appendHighlightedTitle(link, title, query) {
      const normalizedTitle = title.toLocaleLowerCase();
      const normalizedQuery = query.toLocaleLowerCase();
      const matchIndex = normalizedTitle.indexOf(normalizedQuery);

      if (matchIndex === -1) {
        link.textContent = title;
        return;
      }

      link.append(document.createTextNode(title.slice(0, matchIndex)));
      const strong = document.createElement('strong');
      strong.textContent = title.slice(matchIndex, matchIndex + query.length);
      link.append(strong, document.createTextNode(title.slice(matchIndex + query.length)));
    }

    function renderSuggestions(suggestions, query) {
      list.replaceChildren();
      results.hidden = false;
      let renderedCount = 0;

      suggestions.slice(0, 20).forEach((product) => {
        const title = String(product.title || '');
        const handle = String(product.handle || '');
        const root = window.Shopify?.routes?.root || '/';
        const url = product.url || `${root}products/${encodeURIComponent(handle)}`;
        if (!title || (!handle && !product.url)) return;

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = url;
        appendHighlightedTitle(link, title, query);
        item.append(link);
        list.append(item);
        renderedCount += 1;
      });

      empty.hidden = renderedCount > 0;
      recommendations.hidden = renderedCount > 0;
    }

    async function getSuggestions(query) {
      if (products.length) {
        const normalizedQuery = query.toLocaleLowerCase();
        return products.filter((product) =>
          String(product.title || '').toLocaleLowerCase().includes(normalizedQuery)
        );
      }

      abortController?.abort();
      abortController = new AbortController();
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '10',
      });
      const response = await fetch(`${drawer.dataset.suggestUrl}.json?${params}`, {
        signal: abortController.signal,
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
      const data = await response.json();
      return data?.resources?.results?.products || [];
    }

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-custom-search-open]')) {
        event.preventDefault();
        openDrawer();
      }
    });

    drawer.querySelector('[data-custom-search-close]').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
    });

    form.addEventListener('submit', (event) => {
      const query = input.value.trim();
      input.value = query;
      if (query.length < 2) {
        event.preventDefault();
        input.focus();
      }
    });

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(timeoutId);
      if (query.length < 2) {
        list.replaceChildren();
        results.hidden = true;
        empty.hidden = true;
        recommendations.hidden = false;
        return;
      }

      timeoutId = window.setTimeout(async () => {
        try {
          renderSuggestions(await getSuggestions(query), query);
        } catch (error) {
          if (error.name !== 'AbortError') renderSuggestions([], query);
        }
      }, 200);
    });
  }

  document.querySelectorAll('[data-custom-search-drawer]').forEach(initializeCustomSearch);
})();
